import { render, staticRenderFns } from "./StandardDeleteBtn.component.vue?vue&type=template&id=81ef1a02&scoped=true&lang=html&"
import script from "./StandardDeleteBtn.component.vue?vue&type=script&lang=js&"
export * from "./StandardDeleteBtn.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ef1a02",
  null
  
)

export default component.exports